export const es_mapping = {
    title: 'Mappature',
    body: 'Puoi mappare subito gli immobili di tutti i comuni italiani ed individuare velocemente i <b>“don’t wanter”</b> e le operazioni da approfondire.',
    button: 'Crea e Gestisci',
    label_modal_building: 'DETALLE DE LA PROPIEDAD',
    label_data_entry: 'Dati mappatura',
    label_address: 'Dirección',
    label_image: 'Imagen',
    label_mq: 'Mq',
    label_price: 'Precio',
    label_room: 'Habitaciones',
    label_floor: 'Piso',
    label_lift: 'Ascensor?',
    label_bathroom: 'n. Baños',
    label_renovation: 'para ser reestructurado?',
    label_date: 'Fecha',
    label_link: 'Link',
    label_note: 'Nota',
    table_title: 'Tabella immobili mappati',
    table_floor: 'Pisos',
    table_address: 'Dirección',
    table_room: 'Habitaciones',
    table_mq: 'Mc',
    table_price: '€ (€/mc)',
    table_deviation: 'Desv. %',
    totale_immobili:'Total Propiedades',
    table_archive_title: 'Archivo de mapeo',
    table_archive_city: 'Ciudad',
    table_archive_mapped_zone: 'Zone mappate',
    table_zone: 'Zona',
    table_macrozone: 'Macro Zona',
    table_microzone: 'Micro Zona',
    show_link: 'Mostra mappatura',
    hide_link: 'Nascondi',
    free_market:'Mercato Libero',
    add_new_item:'Nuovo Immobile',
    button_import:'Importar las propiedades seleccionadas a la tabla',
    alert_end:'OOOPS! Te has quedado sin búsquedas DIARIAS para tu paquete Real Estate Pro.',
    popover_zone_title: 'Pronto per iniziare!',
    popover_zone_content: '<p>Questa card è il punto di partenza per generare la tua mappatura su una determinata area.\n' +
        'Inserisci città, zona, macrozona e microzona ed incomincia ad inserire gli immobili.</p>',

    popover_list_title: 'Elenco degli immobili',
    popover_list_content: '<p>Adesso puoi inserire gli immobili cliccando su "Importazione manuale" oppure su "Disegna la mappa". ' +


        'Il sistema genererà in automatico la percentuale di scostamento con il colore associato. Ricorda che occorre approfondire gli annunci immobiliari con un\'alta percentuale di scostamento in negativo rispetto allo street price.' +
        '</p>' +
        '<p><span class="abtg__dot abtg__dot-yellow">giallo: da 0 a 10</span> | <span class="abtg__dot abtg__dot-green">verde: da -30 a 0</span> </p>' +
        '<p><span class="abtg__dot abtg__dot-blue">Blu: inferiore a -30</span> | <span class="abtg__dot abtg__dot-black">nero: oltre 10</span></p>' +
        '<p>Qualora decidessi di approfondire l’operazione - ad immobile inserito - puoi cliccare l’icona <i class="fas fa-calculator abtg__fontIcon" style="font-size:140%!important;"></i> per accedere alla scheda dell’operazione e al conto economico. </p>',

    popover_archive_title: 'Il tuo archivio',
    popover_archive_content:
        '<p>In questa card puoi selezionare e gestire le mappature create in base alla regione selezionata sulla mappa.</p>\n',



    popover_scan_title: 'Scan di mercato',
    popover_scan_content: '<p>Attraverso lo Scan di Mercato è sufficiente incollare l\'indirizzo del risultato di ricerca di immobiliare.it nell\'apposito campo". ' +



        '<p>Real Estate Pro eseguirà la medesima ricerca (comprensiva di filtri) direttamente su uno dei due portali.<br>N.b. Lo scan di mercato è attivo solo su immobiliare.it </p>',

        zone_title:'Areas',
        tutte_le_zone: 'Todas las areas',
        first_folder:'Carpeta Principal',
        move:'Mover a..',
        add_folder:'Crear carpeta..',
        folder:'Carpeta:',
        folder_delete_title:'ELIMINAR ESTA CARPETA',
        folder_delete_h3:'¿Está seguro de que desea eliminar esta carpeta?',
        folder_delete_h5:'Todas las zonas contenidas en él se moverán a la carpeta principal',
        folder_delete_no:'No, cambié de opinión',
        folder_delete_si:'Borrar',
        folder_edit_title:'CAMBIAR EL NOMBRE DE LA CARPETA',
        folder_create_title:'CREAR NUEVA CARPETA',
        folder_create_name:'Nombre de la carpeta:',
        folder_edit_name:'Nuevo Nombre:',
        folder_create_error:'Por favor ingrese un nombre valido',
        folder_create:'Crear carpeta',
        folder_edit:'Editar',
        link_modifica_dati_zona: 'Cambiar datos de zona',
        link_aggiorna_mappa: 'Actualizar mapa',
        link_chiudi_info: 'Cerrar toda la info',
        link_cancella_zona: 'Eliminar zona',
        link_nuova_mappatura: 'Nuevo mapeo',
        text_no_mappatura: 'Para esta área no se ha dibujado ningún polígono en el mapa.',
        text_crea_mappa: 'crea el mapa.',
        link_immobili_residenziali: 'Inmuebles Residenciales',
        indifferente:'indiferente',

    filtra:'Filtrar y seleccionar las propiedades a mostrar en la tabla',

        cancellare_disegno:'BORRA EL DISEÑO',
        cerca:'BUSCA INMUEBLES',
        imm_rimanenti:'Inmuebles restantes mensualmente',
        agg_rimanenti:'Actualizaciones de zona mensuales restantes',
        residenziali:'Inmuebles residenciales',
        commerciali:'Inmuebles comerciales',
        link_immobili_commerciali: 'Inmuebles comerciales',
        text_media_prezzo: 'Precio medio/m2',
        text_ricalcolo: 'Recalculo',
        link_esporta_excel: 'Exportar Excel',
        link_carica_immobile: 'Carga immòvil',
        link_controlla_annunci: 'Echa un vistazo a los anuncios caducados',
        link_ricalcola_scostamento: 'Recalcular la desviación',
        text_sto_controllando: 'Estoy comprobando',
        link_cancella: 'Eliminar anuncios que ya no están presentes',
        link_modifica: 'Modificación',
        link_conto: 'Estado de resultados',
        link_cancella_stop: 'Eliminar',
        ristrutturazione: 'renovación',
        warning: '¡Atención! Este anuncio ya no está presente en el portal.',
        link_vai_annuncio: 'Ir al anuncio',
        text_tipologia_immobile: 'Tipo de propiedad',
        check_residenziale: 'Resid.',
        check_commerciale: 'Com.',
        domanda_rinnovato: 'renovado?',
        bottone_salva: 'GUARDAR LOS DATOS',
        label_check_anomalo: 'comprobar si este anuncio',
        link_e_valido: 'Es vàlido',
    doppione: 'Propiedad dúplex. Esta propiedad era similar a otra propiedad en la búsqueda.',
    doppione_vai: 'Ir a propiedad similar!',
    probabile_doppione: 'PROBABLE PROPIEDAD DOBLE!',
    non_e_doppione: 'No es un duplicado.',
    elimina_doppione: 'Eliminar duplicado',
    immobile_gia_importato: 'Propiedad ya importada. Si lo vuelves a importar actualizará el existente.',
    prezzo_diverso: 'El precio de la propiedad ya importada es',
    diverso: 'DIFERENTE',
    lostesso: 'LO MISMO',
    vai_al_dettaglio: 'Ir al detalle en',
    ristrutturato_si: 'Renovado "sì"',
    ristrutturato_ni: 'Renovado "nì"',
    ristrutturato_no: 'Renovado "no"',
    azzera_filtri: 'Restablecer filtros',
};
